import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const StatusWrapper = styled.div`
  display: flex;
  align-items: center;
`;

const StatusIndicator = styled.div`
  margin-right: 8px;
  width: 14px;
  height: 14px;
  border-radius: 50%;
  background: ${props => props.theme.color[props.variant]};
`;

const variants = {
  Active: 'positive',
  Cancelled: 'negative'
};

const ActivityStatus = ({ status }) => {
  if (!status) {
    return null;
  }

  return (
    <StatusWrapper>
      <StatusIndicator variant={variants[status]} />
      <span>{status}</span>
    </StatusWrapper>
  );
};

ActivityStatus.defaultProps = {
  status: undefined
};

ActivityStatus.propTypes = {
  status: PropTypes.oneOf(['Active', 'Cancelled'])
};

export default ActivityStatus;



// WEBPACK FOOTER //
// ./src/features/fuel-cards/activity-status.js